import React, { useEffect, useRef, useState } from "react";

/**
 * Small dialog for adding a dimensions-table column. Renders above AdminEditorModal
 * (z-[12000]), so it works from both the create section and the edit popup.
 */
const AdminAddColumnModal = ({ open, onClose, onSubmit }) => {
  const [label, setLabel] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setLabel("");
    const timer = setTimeout(() => inputRef.current?.focus(), 0);
    return () => clearTimeout(timer);
  }, [open]);

  if (!open) return null;

  const submit = () => {
    const trimmed = label.trim();
    if (!trimmed) return;
    onSubmit?.(trimmed);
  };

  return (
    <div
      className="fixed inset-0 z-[13000] flex items-center justify-center p-4 bg-slate-900/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="admin-add-column-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
      onKeyDown={(e) => {
        // Keep Escape local so the editor modal underneath stays open.
        if (e.key === "Escape") {
          e.stopPropagation();
          onClose?.();
        }
      }}
    >
      <div className="w-full max-w-sm rounded-2xl bg-white border border-slate-200 shadow-2xl p-5">
        <h3 id="admin-add-column-title" className="text-base font-semibold text-[#011337]">
          Add column
        </h3>
        <p className="text-xs text-slate-500 mt-1 mb-3">
          This is the header shown in the table. The internal key is generated automatically
          (e.g. &quot;Fire Rating&quot; &rarr; <code>fireRating</code>).
        </p>
        <input
          ref={inputRef}
          type="text"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              submit();
            }
          }}
          placeholder='e.g. "H2" or "Fire Rating"'
          className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        />
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="text-sm px-3 py-1.5 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={submit}
            disabled={!label.trim()}
            className="text-sm px-3 py-1.5 rounded-lg bg-[#011337] text-white hover:opacity-90 disabled:opacity-50"
          >
            Add column
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminAddColumnModal;
